import { useEffect } from 'react'

export default (ref, offset) =>
  useEffect(() => {
    const shouldUpdateScroll = ref && ref.current && !ref.current.state.isScrolling

    if (shouldUpdateScroll) {
      ref.current.scrollTo(offset)
    }
  })
